<template>
  <div>
    <ComponentTests />
  </div>
</template>

<script>
import ComponentTests from "ninenine-white-label/src/components/Tests/ComponentTests.vue";


export default {
  name: "Tests",

  components: {
    ComponentTests,

  }
}
</script>

<style lang="scss" scoped>

/deep/.btn{
background-color: #25aee3;
border-color: #25aee3;
}
</style>
